import { useEffect, useState } from "react";
import { getBuildMetaSync, loadBuildMeta } from "./buildMeta";

export const useBuildMeta = () => {
  const [meta, setMeta] = useState(getBuildMetaSync());

  useEffect(() => {
    let mounted = true;
    loadBuildMeta()
      .then((value) => {
        if (mounted) setMeta(value);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return meta;
};

